import React, { useEffect, useState } from 'react';
import BtnStandard from '../components/BtnStandard';
import { useParams } from 'react-router';
import Loader from '../components/Loader';
import axios from 'axios';

const Failure = () => {
    const [load, setLoad] = useState(false)
    const { name, aid, token_brand, session_pay } = useParams();
    const init = async () => {
        if(!load && aid && session_pay){
            setLoad(true)
            try{
                await axios.post(process.env.REACT_APP_API + "/pay_routes/failure_no_pay", {
                    session_pay,
                    aid
                });
            }catch(err){

            }
            setLoad(false)
        }
    }
    useEffect(() => {
        init()
    }, [])
    return (
        <div className='page-h100 df aic jcc fdc tac cw fr'>
            {load && (
                <Loader />
            )}
            
            {!load && (
                <>
                    <p className='fbb fs20 cw'>Votre paiement a échoué</p>
                    <p className='fr cw tac fs14'>Nous n'avons pas pu traiter votre demande de paiement</p>
                    <p className='fr fs15 cw'>Veuillez réessayer</p>
                    <div className='mt3'>
                        <BtnStandard label={"Retourner à la page"} click={() => {
                            if (window.self !== window.top) {
                                if(window?.top?.window?.top){
                                    window.parent.parent.postMessage({ closeIframe: true }, "*");
                                }else{
                                    window.parent.postMessage({ closeIframe: true }, "*");
                                }
                            } else {
                                window.location.href = "/product_pay/" + name + `?aid=${aid}&brand=${token_brand}`
                            }
                        }} />
                    </div>
                </>
            )}

        </div>
    );
};

export default Failure;